import Audur from './svg/Audur';
import Kvika from './svg/Kvika';
import KvikaEignastyring from './svg/KvikaEignastyring';
import KvikaNoText from './svg/KvikaNoText';
export { Kvika, KvikaEignastyring, Audur, KvikaNoText };
//# sourceMappingURL=index.js.map